import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnMS: CultureInfo = {
  name: 'en-MS',
  displayName: 'English (Montserrat)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-MS',
  parent: CultureInfoEn
};
